import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";

class TeamMemberModal {
  constructor(component) {
    this.refs = {
      modalWrapper: '.js-team-member-modal-wrapper',
      memberImage: '.js-member-image',
      memberName: '.js-member-name',
      memberRole: '.js-member-role',
      memberLocationBlock: '.js-member-location-block',
      memberLocation: '.js-member-location',
      memberContactBlock: '.js-member-contact-block',
      memberEmailLink: '.js-member-email-link',
      memberPhoneLink: '.js-member-phone-link',
      memberPhoneSpan: '.js-member-phone-span',
      memberIntro: '.js-member-intro',
      memberBio: '.js-member-bio',
      close: '.js-team-member-modal-close',
      card: '.js-team-listing-grid-item',
      underlay: '.js-underlay',
      teamMemberData: '#team-data',
    };

    this.dom = {
      $component: component,
      $modalWrapper: component.querySelector(this.refs.modalWrapper),
      $memberImages: component.querySelectorAll(this.refs.memberImage),
      $memberName: component.querySelector(this.refs.memberName),
      $memberRole: component.querySelector(this.refs.memberRole),
      $memberLocationBlocks: component.querySelectorAll(this.refs.memberLocationBlock),
      $memberLocations: component.querySelectorAll(this.refs.memberLocation),
      $memberContactBlocks: component.querySelectorAll(this.refs.memberContactBlock),
      $memberEmailLinks: component.querySelectorAll(this.refs.memberEmailLink),
      $memberPhoneLinks: component.querySelectorAll(this.refs.memberPhoneLink),
      $memberIntro: component.querySelector(this.refs.memberIntro),
      $memberBio: component.querySelector(this.refs.memberBio),
      $close: component.querySelector(this.refs.close),
      $cards: document.querySelectorAll(this.refs.card),
      $underlay: document.querySelector(this.refs.underlay),
      $teamMemberData: document.querySelector(this.refs.teamMemberData),
    };

    this.state = {
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
      clickedCard: null,
      teamMemberData: null,
    };

    this.closeModal = this.closeModal.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.init();
  }

  init() {
    const { dom, state } = this;

    if (dom.$cards) {
      dom.$cards.forEach(card => {
        card.addEventListener('click', e => this.onCardClick(e, card));
      });
    }

    if (dom.$underlay) {
      dom.$underlay.addEventListener('click', this.closeModal);
    }

    if (dom.$close) {
      dom.$close.addEventListener('click', this.onCloseClick);
    }

    this.getTeamMemberData();
  }

  onCloseClick(e) {
    if (e.detail === 0) {
      this.closeModal({ shouldReturnFocus: true })
      return;
    }

    this.closeModal();
  }

  getTeamMemberData() {
    const { dom, state } = this;
    const teamDataEl = dom.$teamMemberData;
    const teamMemberData = teamDataEl ? JSON.parse(teamDataEl.textContent) : {};
    state.teamMemberData = teamMemberData;
  }

  onCardClick(e, card) {
    e.preventDefault();
    const { dom, state } = this;

    state.clickedCard = card;
    this.openModal();
    this.populateModal(card.dataset?.postName);
  }

  populateModal(postName) {
    const { refs, dom } = this;

    const teamMember = this.findTeamMember(postName);
    const { post, acf: { listing } } = teamMember;

    // Name, role, images
    dom.$memberName.textContent = post.post_title;
    dom.$memberImages.forEach(el => {
      el.src = listing.image.url;
      el.alt = `Headshot of ${post.post_title}`;
    });
    dom.$memberRole.textContent = listing.role;
    dom.$memberLocations.forEach(el => el.textContent = listing.location);

    dom.$memberLocationBlocks.forEach(el => {
      el.classList.toggle('is-hidden', !listing.location);
    });

    dom.$memberContactBlocks.forEach(el => {
      el.classList.toggle('is-hidden', !listing.email && !listing.phone);
    });

    // -----------------------------
    // EMAIL LINK
    // -----------------------------
    dom.$memberEmailLinks.forEach(el => {
      if (!listing.email) {
        el.href = "#";
        el.classList.add('is-hidden');
        return;
      }
      el.href = `mailto:${listing.email}`;
      el.classList.remove('is-hidden');
    });

    // -----------------------------
    // PHONE LINK
    // -----------------------------
    dom.$memberPhoneLinks.forEach(el => {
      const span = el.querySelector(refs.memberPhoneSpan);

      if (listing.phone) {
        // Visible phone number
        if (span) span.textContent = listing.phone;

        // Clean digits for the tel link
        const digits = listing.phone.replace(/[^\d+]/g, '');
        el.href = `tel:${digits}`;
        el.classList.remove('is-hidden');
      } else {
        if (span) span.textContent = '';
        el.href = "#";
        el.classList.add('is-hidden');
      }
    });

    dom.$memberIntro.textContent = listing.intro;
    dom.$memberBio.innerHTML = listing.bio;
  }

  findTeamMember(postName) {
    const { state } = this;
    return state.teamMemberData.find(member => member.post.post_name === postName);
  }

  openModal() {
    const { dom, state } = this;

    this.toggleModalState(true);

    state.focusTrap = state.accessibilityHelper.buildFocusTrap(dom.$modalWrapper);
    state.focusTrap.set();

    state.accessibilityHelper.addEscapeKeyListener(() => this.closeModal({ shouldReturnFocus: true }));
  }

  closeModal(options) {
    const { dom, state } = this;
    if (state.focusTrap) {
      state.focusTrap.unset();
      state.focusTrap = null;
    }
    if (options?.shouldReturnFocus) {
      state.clickedCard.focus();
    } else {
      document.activeElement.blur();
    }

    this.toggleModalState(false);
    state.accessibilityHelper.removeEscapeKeyListener();
  }

  toggleModalState(isActive) {
    const { dom } = this;

    document.body.classList.toggle('scroll-locked', isActive);

    dom.$underlay.classList.toggle('is-active', isActive);
    dom.$underlay.classList.toggle('is-over-nav', isActive);
    dom.$component.classList.toggle('is-open', isActive);
    dom.$component.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  const $teamMemberModal = document.querySelector('.js-team-member-modal');
  if (!$teamMemberModal) return;
  new TeamMemberModal($teamMemberModal);
});
